import { Routes } from '@angular/router';
import { ReportBuilderComponent } from './components/builder/report-builder.component';
import { ReportBuilderMyReportsComponent } from './components/my-reports/report-builder-my-reports.component';
import { ReportBuilderSharedReportsComponent } from './components/my-reports/report-builder-shared-reports.component';
import { ReportBuilderScheduledReportsComponent } from './components/my-reports/report-builder-scheduled-reports.component';
import { ReportBuilderSavedReportsComponent } from './components/my-reports/report-builder-saved-reports.component';
import { ReportPresetsComponent } from './components/presets/report-presets.component';
import { ReportPresetsGroupingByDaysComponent } from './components/presets/report-presets-grouping-by-days.component';
import { ReportPresetsImpressionsWidgetSizeByDayComponent } from './components/presets/report-presets-impressions-widget-size-by-day.component';
import { ReportPresetsWinRateComponent } from './components/presets/report-presets-win-rate.component';
import { ReportPresetsDpLandscapeComponent } from './components/presets/report-presets-dp-landscape.component';
import { PRESET_REPORT_IDS } from './components/presets/report-preset.model';
import { ReportPresetsNegativeProfitabilityUnitsComponent } from './components/presets/revops/report-presets-negative-profitability-units.component';
import { ReportPresetsNegativeMarginUnitsComponent } from './components/presets/revops/report-presets-negative-margin-units.component';
import { ReportPresetsReadyToActiveComponent } from './components/presets/adops/report-presets-ready-to-active.component';
import { ReportPresetsTopMissingAdstxtComponent } from './components/presets/adops/report-presets-top-missing-adstxt.component';
import { ReportPresetsBidderUnitsComponent } from './components/presets/revops/report-presets-bidder-units.component';
import { ReportPresetsEbdaUnitsComponent } from './components/presets/revops/report-presets-ebda-units.component';
import { ReportPresetsVideoUnitsComponent } from './components/presets/adops/report-presets-video-units.component';

export const reportBuilderRoutes: Routes = [
  {
    path: '',
    redirectTo: 'builder',
    pathMatch: 'full',
  },
  {
    path: 'builder',
    component: ReportBuilderComponent
  },
  {
    path: 'saved',
    component: ReportBuilderSavedReportsComponent,
    children: [
      {
        path: '',
        redirectTo: 'my',
        pathMatch: 'full',
      },
      {
        path: 'my',
        component: ReportBuilderMyReportsComponent
      },
      {
        path: 'shared',
        component: ReportBuilderSharedReportsComponent
      },
      {
        path: 'scheduled',
        component: ReportBuilderScheduledReportsComponent
      }
    ]
  },
  {
    path: 'presets',
    component: ReportPresetsComponent,
    children: [
      {
        path: '',
        redirectTo: 'unit-review',
        pathMatch: 'full',
      },
      {
        path: PRESET_REPORT_IDS.unitReview,
        component: ReportPresetsGroupingByDaysComponent
      },
      {
        path: PRESET_REPORT_IDS.impressionsByDay,
        component: ReportPresetsImpressionsWidgetSizeByDayComponent
      },
      {
        path: PRESET_REPORT_IDS.dpUnitLandscape,
        component: ReportPresetsDpLandscapeComponent
      },
      {
        path: PRESET_REPORT_IDS.winRate,
        component: ReportPresetsWinRateComponent
      },
      {
        path: PRESET_REPORT_IDS.revopsNegativeProfitabilityUnits,
        component: ReportPresetsNegativeProfitabilityUnitsComponent
      },
      {
        path: PRESET_REPORT_IDS.adopsTop25missingAdsTxt,
        component: ReportPresetsTopMissingAdstxtComponent
      },
      {
        path: PRESET_REPORT_IDS.revopsBidderUnits,
        component: ReportPresetsBidderUnitsComponent
      },
      {
        path: PRESET_REPORT_IDS.revopsNegativeMarginUnits,
        component: ReportPresetsNegativeMarginUnitsComponent
      },
      {
        path: PRESET_REPORT_IDS.adopsReadyToActive,
        component: ReportPresetsReadyToActiveComponent
      },
      {
        path: PRESET_REPORT_IDS.revopsEbdaUnits,
        component: ReportPresetsEbdaUnitsComponent
      },
      {
        path: PRESET_REPORT_IDS.adopsVideoUnits,
        component: ReportPresetsVideoUnitsComponent
      },
    ]
  }
];
